import gql from 'graphql-tag'
import { client } from '../utils/GQLClient'
import { accountQuery } from './__generated__/types'

const ACCOUNT_QUERY = gql`
  query accountQuery($subdomain: String!) {
    account(subdomain: $subdomain) {
      id
      name
      type
      hasPTDFeature
    }
  }
`

export function getAccount(subdomain: string) {
  return client.query<accountQuery>({
    query: ACCOUNT_QUERY,
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
    variables: { subdomain }
  })
}
